



























































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import TravelFilter from "@/components/filter/TravelFilterSection.vue";
import TravelLayoutCard from "@/components/cards/TravelLayoutCard.vue";
import PlaceholderCard from "@/components/cards/PlaceholderCard.vue";
import TravelAlternativeLink from "@/components/travel/TravelAlternativeLink.vue";
import TravelOrdering from "@/components/TravelOrdering.vue";
import ThemeSwitcher from "@/components/ThemeSwitcher.vue";
import ButtonCommon from "@/components/lib/ButtonCommon.vue";
import viewMetaMixin from "@/mixins/viewMetaMixin";
import { onLoadJumpMixin } from "@/mixins/onScrollAnimationMixin";
import onLocaleChangeMixin from "@/mixins/onLocaleChangeMixin";
import { updateItems } from "@/lib";
import { ITravel, ITravelFilterData } from "@/entities";
import { ISort, Sort } from "@/components/lib/models";
import { isEqual } from "lodash";

@Component({
  components: {
    TravelFilter,
    TravelLayoutCard,
    TravelOrdering,
    ThemeSwitcher,
    ButtonCommon,
    PlaceholderCard,
    TravelAlternativeLink,
  },
})
export default class Travels extends Mixins(
  viewMetaMixin,
  onLoadJumpMixin,
  onLocaleChangeMixin
) {
  protected reFetches = [this.updateTravels];

  private travelsLimit: number = 12;
  private waiting: boolean = true;
  protected fetching: boolean = false;

  get showLoading(): boolean {
    return this.waiting || this.fetching;
  }

  private next: string = "";

  private sortingData: ISort = new Sort();

  private travels: ITravel[] = [];

  private foundCounter: number = 0;

  private resetFetchParams(): void {
    this.next = "";
    this.foundCounter = 0;
    this.travels = [];
  }

  get orderingQuery(): string {
    return (
      (this.sortingData.direction === "direct" ? "-" : "") +
      this.sortingData.field
    );
  }

  get travelFormatRequest(): boolean {
    return this.$store.state.getTravelFormatRequest;
  }
  get sherpaLink(): string {
    return `https://apply.joinsherpa.com/travel-restrictions?language=${this.$i18n.locale}`;
  }
  private fetchTravels(): void {
    if (this.fetching) return;
    this.fetching = true;

    if (isEqual(this.$store.state.travelFormatRequest, "group")) {
      this.filtersData.travel_format = ["group"];
    }

    if (isEqual(this.$store.state.travelFormatRequest, "single")) {
      this.filtersData.travel_format = ["single"];
    }

    if (isEqual(this.$store.state.travelFormatRequest, "individual")) {
      this.filtersData.travel_format = ["individual"];
    }

    this.$storage.actions
      .fetchTravels({
        payload: {
          ...this.filtersData,
          page_size: this.travelsLimit,
          ordering: this.orderingQuery,
        },
        config: this.next
          ? {
              baseURL: "",
              url: this.next,
            }
          : undefined,
      })
      .then((res) => {
        this.foundCounter = res.count || 0;
        this.next = res.next || "";
        this.travels.push(...res.results);
      })
      .catch(() => {
        this.resetFetchParams();
      })
      .finally(() => {
        this.fetching = false;
      });
  }
  mounted(): void {
    this.$store.dispatch("setCheckboxLabelColor", true);
  }
  private updateTravels(): void {
    updateItems<ITravel>(this.travels, this.$storage.actions.getTravelById);
  }

  private reFetchTravels(): void {
    this.resetFetchParams();
    this.fetchTravels();
  }

  get travelsToShow(): ITravel[] {
    return this.travels.filter((travel: ITravel) => travel.validate());
  }

  get mayHaveItems(): boolean {
    return !!this.travelsToShow.length || this.showLoading;
  }

  get filtersData(): ITravelFilterData {
    return this.$store.state.filters;
  }

  protected updateSorting(sorting: ISort): void {
    this.sortingData = sorting;
    // if there are two or more records to ordering
    if (this.foundCounter > 1) {
      this.reFetchTravels();
    }
  }

  private getCustomPlan(): void {
    this.$storage.actions.setModal({
      name: "ModalPlan",
      from: "travels",
    });
  }

  @Watch("filtersData", { deep: true })
  protected onFiltersDataChanged(): void {
    this.waiting = false;
    this.reFetchTravels();
    this.$store.dispatch("setTravelFormatRequest", undefined);
  }
}
